import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { DataService } from "@app/services/data.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent {

  constructor(public router: Router, public dataService: DataService) {
  }

    @Input() items: { link: string; title: string; order: string; }[] = [];

    public isDoz(): boolean {
      return this.dataService.userRoleValue.getValue() === "DOZ";
    }
}
